export function unwrapProxy(proxyObj: any): any {
  return JSON.parse(JSON.stringify(proxyObj));
}